import { createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')","background-color":"#597dfe !important"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/logo.png",
    class: "h-45px"
  })
], -1)
const _hoisted_4 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "p-5" }
const _hoisted_7 = { align: "justify" }
const _hoisted_8 = { align: "justify" }
const _hoisted_9 = { align: "justify" }
const _hoisted_10 = { align: "justify" }
const _hoisted_11 = { class: "p-5" }
const _hoisted_12 = { align: "justify" }
const _hoisted_13 = { align: "justify" }
const _hoisted_14 = { align: "justify" }
const _hoisted_15 = { align: "justify" }
const _hoisted_16 = { align: "justify" }
const _hoisted_17 = { align: "justify" }
const _hoisted_18 = { align: "justify" }
const _hoisted_19 = { align: "justify" }
const _hoisted_20 = { align: "justify" }
const _hoisted_21 = { align: "justify" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><a href=\"#\" class=\"text-muted text-hover-primary px-2\">About</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact Us</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("h1", null, _toDisplayString(_ctx.translate("termsh1")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh41")), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.translate("termsp1")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh42")), 1),
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.translate("termsp2")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh43")), 1),
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.translate("termsp3")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh44")), 1),
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.translate("termsp4")), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("h1", null, _toDisplayString(_ctx.translate("termsh11")), 1),
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.translate("termsp11")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh45")), 1),
            _createVNode("p", null, _toDisplayString(_ctx.translate("termsp5")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh46")), 1),
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.translate("termsp6")), 1),
            _createVNode("p", _hoisted_14, _toDisplayString(_ctx.translate("termsp61")), 1),
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.translate("termsp62")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh47")), 1),
            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.translate("termsp7")), 1),
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.translate("termsp71")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh48")), 1),
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.translate("termsp8")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.translate("termsh49")), 1),
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.translate("termsp9")), 1),
            _createVNode("p", _hoisted_20, _toDisplayString(_ctx.translate("termsp91")), 1),
            _createVNode("p", _hoisted_21, _toDisplayString(_ctx.translate("termsp92")), 1)
          ])
        ])
      ])
    ]),
    _hoisted_22
  ]))
}